import PieChartIcon from "@mui/icons-material/PieChart";
import permissions from "app/permissions";
import {
  ReportingServicePath,
  REPORTS_FINANCIAL,
  REPORTS_PRELIMINARY_CANDIDATE,
  REPORTS_STUDENT,
} from "utils/constants";
import ReportsList from "./CandidateReports/List";
import { REPORT_CATEGORIES } from "./CandidateReports/reports/_data";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <PieChartIcon />,
  name: "Справки",
  title: "Справки",
  subMenu: [
    {
      isMenu: true,
      tenancies: [tenants.MU],
      icon: <PieChartIcon />,
      title: "КСК",
      name: ReportingServicePath + REPORTS_PRELIMINARY_CANDIDATE,
      permission: permissions.canSeeMenuReports,
      list: <ReportsList category={REPORT_CATEGORIES.CandidateCampaigns} />,
    },
    {
      isMenu: true,
      tenancies: [tenants.MU],
      icon: <PieChartIcon />,
      title: "Финанси",
      name: ReportingServicePath + REPORTS_FINANCIAL,
      permission: permissions.canSeeMenuReports,
      list: <ReportsList category={REPORT_CATEGORIES.Financial} />,
    },
    {
      isMenu: true,
      tenancies: [tenants.MU, tenants.MGU],
      icon: <PieChartIcon />,
      title: "Студентски данни",
      name: ReportingServicePath + REPORTS_STUDENT,
      permission: permissions.canSeeMenuReports,
      list: <ReportsList category={REPORT_CATEGORIES.Student} />,
    },
  ],
};
